__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-common/v9_8_3/";